import axios from 'axios';
import store from '@/store';
import { ElMessage } from 'element-plus';
import router from '@/router/index';
const baseURL = process.env.VUE_APP_BASE_URL;
//const baseURL= 'http://192.168.2.31:8109'; //本地调试地址

const service= axios.create({
  baseURL: baseURL,
  timeout: 50000
});
// 请求前的统一处理
service.interceptors.request.use(
  (config) => {
    if (store.getters['user/token'] && config && config.headers) {
      config.headers['Authorization'] = store.state.user.token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => {
    if (response?.data?.code === 200) {
      // 如果接口返回code为200，或者用户配置了自定义处理错误，则直接返回数据
      return response.data;
    } else {
      //统一处理错误
      showError(response.data || response, response.config);
      return Promise.reject(response.data || response);
    }
  },
  error => {
    const badMessage= error.message || error
    showError({ message: badMessage });
    return Promise.reject(error);
  }
);

// 错误处理
function showError(error) {
  // token过期，清除本地数据，并跳转至登录页面
  if (error.code == 666 || error.code == 401) {
    store.dispatch('user/clearAuthAndUserInfo')
    router.push('/login');
  } else if (error.code === 403) {
    router.push('/401');
  } else {
    ElMessage({
      message:   error.msg || error.message || '服务异常',
      type: 'error',
      duration: 3 * 1000,
    });
  }
}
export default service;
